import { render, staticRenderFns } from "./NewDistrict.vue?vue&type=template&id=08e520fc&scoped=true"
import script from "./NewDistrict.vue?vue&type=script&lang=js"
export * from "./NewDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e520fc",
  null
  
)

export default component.exports